module.exports = __webpack_public_path__ + "img/je.a9400996.svg";